import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'I’m already on HRT, can I use this?',
    a: 'Yes. This protocol supports your body’s natural chemistry and works perfectly alongside medical treatments.'
  }, {
    q: 'Is the food expensive or hard to find?',
    a: 'No. Everything can be found at a regular grocery store. It’s about how you combine the foods, not how much they cost.'
  }, {
    q: 'How long until I see results?',
    a: 'Most women feel a shift in their "internal temperature" within the first 48 hours.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-cream" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <FadeIn data-id="element-44">
          <h2 className="text-3xl md:text-4xl text-teal mb-12 text-center" data-id="element-45">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4" data-id="element-46">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl overflow-hidden border border-sage/20 transition-all duration-300" data-id="element-47">
                <button className="w-full text-left p-6 flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-48">
                  <span className="text-lg font-serif text-teal font-medium pr-8" data-id="element-49">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-coral transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-51">
                  <p className="p-6 pt-0 text-charcoal/80 leading-relaxed" data-id="element-52">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}